import { reactive } from 'vue'
import actions from '@/store/mockExam/actions'
import state from '@/store/mockExam/state'
import getters from '@/store/mockExam/getters'

export const mockExamModule = {
    state: reactive(state),
    actions,
    getters,
}
